import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15 4.33211V7.83303M15 7.83303H11.7273M15 7.83303L12.4691 5.28902C11.8829 4.66161 11.1576 4.20328 10.361 3.95679C9.56441 3.71031 8.72242 3.68371 7.91361 3.87947C7.1048 4.07524 6.35553 4.48698 5.73571 5.0763C5.11589 5.66561 4.64573 6.41328 4.36909 7.24954M3 13.6679V10.167M3 10.167H6.27273M3 10.167L5.53091 12.711C6.11714 13.3384 6.84239 13.7967 7.63899 14.0432C8.43559 14.2897 9.27758 14.3163 10.0864 14.1205C10.8952 13.9248 11.6445 13.513 12.2643 12.9237C12.8841 12.3344 13.3543 11.5867 13.6309 10.7505",
  stroke: "currentColor",
  "stroke-width": "1.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }